import React from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface WelcomeMessageProps {
    message: {
        type: string
        text?: string
        [key: string]: any
    }
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ message }) => {
    return (
        <div className="flex justify-center my-4">
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-full px-6 py-3 shadow-sm">
                <div className="flex items-center gap-2">
                    <svg
                        className="w-5 h-5 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                        />
                    </svg>
                    <Typogaphy className="text-sm font-medium text-green-800">
                        {message?.text ||
                            'Chào mừng bạn đến với cuộc trò chuyện'}
                    </Typogaphy>
                </div>
            </div>
        </div>
    )
}

export default WelcomeMessage
